module.exports = __webpack_public_path__ + "img/LOGO-mag.6df0af97.png";